{
  "config": {
    "batch_intro": "{n, plural, one {# fair-play number from your plan waits} other {# fair-play numbers from your plan wait}} as one batch. They take effect only when you approve them.",
    "batch_see_all": "See all {n}",
    "batch_approve": "Approve all {n}",
    "batch_heading": "Stage {stage}: its first fair-play numbers",
    "emergency": "Emergency: start it now, even in a live event",
    "waiting_heading": "Waiting for your approval ({n})",
    "waiting_heading_plain": "Waiting for your approval",
    "settings_heading": "Settings ({n})",
    "settings_heading_plain": "Settings",
    "settings_none": "No setting is active yet.",
    "proofs_label": "Proofs this number feeds",
    "try_again": "Try again",
    "group_fair": "Fair play numbers ({n})",
    "group_fair_intro": "Each of these waits for an owner. It cannot be approved while a proof it feeds is red.",
    "group_other": "Other changes ({n})",
    "group_batch_other": "Other numbers in this batch ({n})",
    "range": "From {min} to {max}",
    "range_fixed": "Fixed at {v}",
    "range_none": "No range is set",
    "range_one_cap": "None: the one-cap check below decides",
    "thoughts_not_run": "The check of the twelve thoughts has not run for this value yet. Each must be the best pick on at least {line} of its strokes.",
    "thoughts_caption": "The twelve thoughts with this value. The line is {line}.",
    "thoughts_under": "{n, plural, one {# thought is} other {# thoughts are}} under the line of {line}: {names}.",
    "thoughts_all_pass": "All twelve thoughts pass the line of {line}. The lowest is {name}, on {share}.",
    "thoughts_see_all": "All twelve thoughts",
    "one_cap_not_run": "The one-cap check has not run for this value yet. It cannot be approved until it has.",
    "one_cap_figures": "With this value the free player reaches a 10 handicap in {free} weeks, and the fastest spender in {spender} weeks. After a year the gap is {gap} shots.",
    "one_cap_breaks": "Breaks the one cap: the fastest spender gets there {saved} sooner. The most allowed is {line}.",
    "one_cap_inside": "Inside the one cap: the fastest spender gets there {saved} sooner. The most allowed is {line}.",
    "thought_share": "{name} ({share})",
    "loading": "Loading…",
    "load_failed": "This list could not be loaded. Check your internet, then try again."
  },
  "thoughts": {
    "under": "Under the line",
    "over": "Passes"
  },
  "proof_state": {
    "green": "Passed",
    "red": "Failed",
    "not_run": "Not run yet"
  },
  "sim": {
    "heading": "Simulation",
    "intro": "The engine's versions, its named proofs and its test runs. This page changes nothing by itself.",
    "loading": "Loading…",
    "versions_heading": "Engine versions ({n})",
    "no_versions": "No engine version is stored yet.",
    "state_in_use": "In use",
    "state_retired": "Retired",
    "state_stopped": "Stopped",
    "state_clear": "Ready",
    "stops_heading": "What stops it",
    "block_not_run": "{proof}: no full run on this version yet.",
    "block_not_run_many": "{n} proofs have no full run on this version yet: {proofs}.",
    "block_red": "{proof}: its last full run on this version failed.",
    "block_thought": "{proof}: {n, plural, one {# thought is} other {# thoughts are}} under the line of {line} ({names}).",
    "block_drift": "Last night's run on version {version} drifted. New versions wait until it is fixed.",
    "nothing_stops": "Nothing stops it. It still needs the founder's yes.",
    "activate": "Activate",
    "roll_back": "Roll back",
    "activate_off": "These two buttons are off. The queue has no request for an engine version yet, so this page cannot send one. The database also refuses a version that a proof stops.",
    "calibration_heading": "Calibration",
    "latest_run": "Latest run:",
    "counted_run": "Last run that counts:",
    "run_line": "{size, select, short {Short} nightly {Nightly} full {Full} gate {Gate} other {A}} run, {at, date, medium} at {at, time, short}, version {version}",
    "calibration_counts": "{inside} of {gated} measures are inside their targets.",
    "outside_summary": "{n, plural, one {# measure is outside its target} other {# measures are outside their targets}}",
    "measure": "{m, select, fairways_pct {Fairways hit (%)} gir_pct {Greens in regulation (%)} up_and_down_pct {Up and down (%)} putts {Putts a round} penalties {Penalty strokes a round} three_putt_pct_of_holes {Three-putts (% of holes)} driver_total_yd {Driver total distance} other {{w}}}",
    "anchor_caption": "The anchor check: where each level settled on the handicap scale.",
    "send_anchor": "Send a new anchor for approval",
    "send_anchor_off": "This button is off. There is no setting for the anchors yet, so a new anchor cannot be filed.",
    "no_calibration_runs": "No calibration run with results band by band is stored in the database yet.",
    "results_caption": "The last stored run, band by band ({n} rows)",
    "run_now": "Run now",
    "run_now_off": "Run now is off. No test worker runs in this build, so it would do nothing. The builder makes each run, and its result shows here once it is stored.",
    "proofs_heading": "The named proofs ({n})",
    "proofs_intro": "A run that counts is a gate run or a full run. A proof that has not run counts as red.",
    "gates_stage_2": "Gates Stage 2",
    "measured_summary": "What it measured",
    "run_says": "The run says:",
    "same_run": "the same run",
    "later_summary": "{n, plural, one {# proof for a later stage has not run yet} other {# proofs for later stages have not run yet}}: {names}",
    "try_again": "Try again",
    "report_kept": "Its report is kept with the build:",
    "thoughts_heading": "The thought line",
    "thoughts_intro": "Each of the twelve thoughts must be the best pick on at least {line} of the strokes of its family.",
    "thoughts_caption": "The last judgement run. The line is {line}.",
    "thoughts_not_measured": "The judgement run has not measured the twelve thoughts yet.",
    "editor_heading": "Parameter editor",
    "editor_intro": "Ask for a new value for one of the engine's fair-play numbers. This only files a request. Nothing changes until an owner says yes in Settings and approvals.",
    "editor_key": "Number",
    "editor_choose": "Choose a number",
    "editor_value": "New value",
    "editor_reason": "Why",
    "editor_file": "File the request",
    "filed": "Filed. It now waits for an owner's yes in Settings and approvals."
  },
  "rounds": {
    "heading": "Round inspector",
    "intro": "Open a finished round to see how it was played. A round still in play is never opened here. Each time you open one, it goes in the log with your reason.",
    "round_label": "Round number",
    "reason_label": "Why you open it (a ticket number is fine)",
    "loading": "Opening the round…",
    "open": "Open the round",
    "summary_heading": "The round",
    "f_status": "Status",
    "f_style": "Play style",
    "f_kind": "Kind",
    "f_mode": "Mode",
    "f_engine": "Engine version",
    "f_holes": "Holes played",
    "f_gross": "Gross",
    "f_net": "Net",
    "f_points": "Points",
    "f_caddie": "Caddie level",
    "f_started": "Started",
    "f_finished": "Finished",
    "seed_heading": "Seed and check",
    "seed_commit": "Seed commit",
    "seed_reveal": "Seed (shown once the round ended)",
    "config_hash": "Settings fingerprint",
    "when": "{at, date, medium} at {at, time, short}",
    "rerun_none": "The server has not checked this round yet.",
    "rerun_ok": "The server played it again and got the same card ({at, date, medium}).",
    "rerun_ok_undated": "The server played it again and got the same card.",
    "rerun_bad": "The server played it again and got a different card ({at, date, medium}).",
    "rerun_bad_undated": "The server played it again and got a different card.",
    "rerun": "Re-run",
    "rerun_off": "Re-run is off here. The server checks every finished round by itself, and its result is shown above. This page cannot start a check in this build.",
    "meters_heading": "Energy, focus and time",
    "e_start": "Energy at the start",
    "e_used": "Energy used",
    "e_food": "Energy food gave back",
    "e_end": "Energy at the end",
    "focus_start": "Focus at the start",
    "focus_left": "Focus at the end",
    "bank_start": "Time bank at the start (seconds)",
    "bank_left": "Time bank left (seconds)",
    "context_heading": "What the round knew at the start",
    "book_none": "Course book: none was in force.",
    "book_yes": "Course book in force: {id}, made by {by}.",
    "ctx_golfer": "The golfer at the start",
    "ctx_conditions": "The conditions",
    "ctx_routine": "The Routine",
    "ctx_plan": "The Game plan",
    "ctx_lines": "The score lines at the start",
    "holes_heading": "Holes ({n})",
    "holes_none": "No hole score is stored for this round.",
    "strokes_heading": "Strokes ({n})",
    "strokes_intro": "Open a stroke to see what the golfer was shown beside what really happened.",
    "stroke_head": "Hole {hole}, shot {shot}: {club}, {from} to {to}",
    "stroke_dist": "{total}, strokes gained {sg}",
    "shown": "What the golfer was shown",
    "ledger": "What happened (the ledger)",
    "intent": "The shot asked for",
    "reason": "The reason line",
    "flight": "The flight block",
    "decisions_heading": "Decisions ({n})",
    "decision_head": "Hole {hole}, shot {shot}: {family} ({kind})",
    "decision_head_between": "Hole {hole}, between shots: {family} ({kind})",
    "decision_meta": "Made by {who}. It cost {secs} seconds and {focus} focus.",
    "choice": "The choice:",
    "choice_full": "{n, plural, one {The choice in full (# part)} other {The choice in full (# parts)}}"
  },
  "courses": {
    "heading": "Courses waiting for review",
    "intro": "Each course here was made by the course program from real map and height data. Look at it, then approve it or send it back. Nothing goes live until you approve it.",
    "empty": "No course is waiting for review.",
    "loading": "Loading the courses waiting for review…",
    "error": "The list did not load. Check your internet, then press Try again.",
    "count": "{n, plural, one {# course is waiting} other {# courses are waiting}}",
    "style": "Style: {style}",
    "site": "Made from map site {site}, seed {seed}",
    "flagship": "Flagship: needs your own sign-off",
    "partner": "Partner club: needs your own sign-off",
    "checks_ok": "Every automatic check passed.",
    "checks_failed": "{n, plural, one {# automatic check failed} other {# automatic checks failed}}. This course cannot be approved.",
    "on_hole": "Hole {hole}: {message}",
    "whole_course": "Whole course: {message}",
    "name_ok": "The name is not like any real club the check knows.",
    "name_hits": "{n, plural, one {The name is close to # real name} other {The name is close to # real names}}: {names}.",
    "copy_ok": "No hole copies a real hole on this site.",
    "copy_hits": "{n, plural, one {# hole is close to a real hole} other {# holes are close to real holes}}.",
    "picture_check": "The picture check is not built yet. Look at every hole yourself before you approve.",
    "tees_heading": "Tees and first ratings",
    "tee_line": "{name}: {length}, par {par}",
    "tee_rating": "First rating {scratch} (bogey {bogey}, difficulty {df})",
    "figures": "{bunkers} bunkers, water on {water} holes, {trees} trees, greens {green_m2} m² in all",
    "reason_label": "Reason (what you looked at, or why you send it back)",
    "looked": "I have looked at every hole myself",
    "founder": "Founder's sign-off: I approve this course",
    "approve": "Approve",
    "reject": "Reject",
    "remake": "Reject and make it again",
    "needs_heading": "Approve stays off until you:",
    "needs_checks": "send it back: a course with a failed check is never approved",
    "needs_reason": "write a reason",
    "needs_looked": "tick that you have looked at every hole",
    "needs_founder": "tick the founder's sign-off",
    "done_approve": "Approved. The course is live.",
    "done_reject": "Rejected. It will not go live.",
    "done_remake": "Rejected. The site will be made again with a new seed."
  },
  "in_play": {
    "heading": "Courses in play",
    "intro": "Make a course again on a new seed, or take it out of play. The course stays in play until its new version is approved.",
    "loading": "Loading the courses in play…",
    "error": "The courses in play could not be loaded.",
    "empty": "No course is in play yet.",
    "line": "Style: {style}, version {version}",
    "waiting": "A new version is being made. It will come to the review queue above.",
    "reason_label": "Reason for {name}",
    "regenerate": "Make it again",
    "pull": "Take out of play",
    "pull_confirm": "Take {name} out of play? Players can no longer travel there or play there. This cannot be undone from the console.",
    "done_regenerate": "{name} will be made again on a new seed.",
    "done_pull": "{name} is out of play."
  },
  "course_check": {
    "schema": "the course data is not in the right shape",
    "inside_plot": "part of the hole is outside the land",
    "no_crossing": "the hole crosses or touches another hole",
    "pars": "the pars do not add up to the course's target, or are in a bad order",
    "lengths": "the length is outside the style's range",
    "greens": "a pin is too near the edge of the green, or on ground that is too steep",
    "walks": "the walk from the green to the next tee is too long",
    "original": "the hole is too close to a real hole",
    "size": "the hole's data is over the size limit"
  },
  "closures": {
    "heading": "Disaster closures",
    "intro": "Use this only when a real disaster, such as a flood or a hurricane, reaches an area. Every course there closes until you reopen it. Nothing closes or reopens by itself. Players see only the short note you choose.",
    "loading": "Loading the closures…",
    "error_load": "The closures did not load. Check your internet, then press Try again.",
    "not_yours": "Only an owner can use this page. The backup contact can use it only while away mode is on.",
    "pause_on": "The AI pause is on. The AI writes nothing about the weather or a closed area.",
    "pause_off_now": "The AI pause is off.",
    "active_heading": "{n, plural, =0 {Closed now: none} one {Closed now: # closure} other {Closed now: # closures}}",
    "none_active": "No area is closed.",
    "past_heading": "{n, plural, one {Every past closure (#)} other {Every past closure (#)}}",
    "new_heading": "Close an area",
    "backup_note": "You are the backup contact. You can close an area with an approved note as it stands. You cannot change its words, answer its review or reopen it: the founder does that.",
    "zone_legend": "How to pick the area",
    "zone": {
      "areas": "By county or state",
      "circle": "A circle on the map",
      "polygon": "A shape on the map"
    },
    "areas_legend": "Counties and states",
    "no_areas": "No counties or states are loaded yet. Use a circle or a shape.",
    "lat": "Centre latitude",
    "lon": "Centre longitude",
    "radius": "Radius in kilometres",
    "polygon": "The shape, as GeoJSON",
    "area_name": "The area's name, as players will read it",
    "part_of_area": "Only part of this area is closed",
    "kind_label": "What has happened",
    "kind_pick": "Pick one",
    "kind": {
      "flood": "Flood",
      "storm": "Severe storm",
      "hurricane": "Hurricane, typhoon or cyclone",
      "wildfire": "Wildfire",
      "earthquake": "Earthquake",
      "volcano": "Volcanic eruption",
      "tsunami": "Tsunami",
      "extreme_heat": "Extreme heat",
      "extreme_cold": "Extreme cold",
      "other": "Other emergency"
    },
    "tropical_label": "The word used in this region",
    "tropical_auto": "Use the region's own word",
    "template_label": "The note",
    "template_option": "{key}, version {version}",
    "preview": "Show what this would close",
    "preview_heading": "What this would close",
    "preview_courses": "{n, plural, one {# course would close.} other {# courses would close.}}",
    "preview_no_clubs": "No club is in this area.",
    "preview_clubs": "Clubs in this area: {names}",
    "preview_later": "Events, bookings, businesses and plot auctions are not built yet, so none can be touched. No message is sent by this page.",
    "note_heading": "The note players will see",
    "note_edit": "You can change the words",
    "note_rule": "Use general words only, such as “because of the hurricane in this area”. Never a storm's given name, a number, a price, an offer or a link.",
    "note_u18_heading": "Players under 18 see these words:",
    "problem": {
      "empty": "The note is empty.",
      "too_long": "The note is too long.",
      "has_number": "The note has a number in it.",
      "has_link": "The note has a link in it.",
      "has_offer": "The note has a price or an offer in it.",
      "unfilled": "Part of the note was not filled in.",
      "exclamation": "The note has an exclamation mark.",
      "forbidden_word": "The note uses a word or a name that is not allowed."
    },
    "reason": "Why (only admins see this)",
    "checked": "What I checked (the official warnings)",
    "typed": "Type the area's name to confirm: {area}",
    "code_label": "6-digit code",
    "code_wrong": "That code did not work. Wait for a new code, then try again.",
    "needs_heading": "Before you can close it:",
    "needs_preview": "Show what this would close",
    "needs_reason": "Write why",
    "needs_checked": "Write what you checked",
    "needs_typed": "Type the area's name exactly",
    "close_button": "{n, plural, =0 {Close the area} one {Close # course} other {Close # courses}}",
    "done_close": "{n, plural, one {Closed # course in {area}.} other {Closed # courses in {area}.}}",
    "status": {
      "active": "Closed",
      "lifted": "Reopened"
    },
    "by_backup": "Closed by the backup contact",
    "since": "Closed since {at}. Review by {review}.",
    "lifted": "Closed {from}, reopened {to}.",
    "due": "This closure is due for review: is it still needed?",
    "overdue": "This closure is more than a day past its review. Please review it now.",
    "course_count": "{all, plural, one {{closed} of # course still closed} other {{closed} of # courses still closed}}",
    "details": "Courses, reason and history",
    "reason_was": "Reason: {reason}",
    "checked_was": "Checked: {checked}",
    "template_was": "Note: {key}, version {version}",
    "reopened_at": "reopened {at}",
    "host": "members play at {club}",
    "no_host": "no host club",
    "history": "History, newest first",
    "history_line": "{at}: {what}. {reason}",
    "command": {
      "close_area": "Closed",
      "review": "Reviewed: still closed",
      "reopen": "Reopened"
    },
    "pause_off": "This is the last closure: also switch the AI sensitivity pause off",
    "still_closed": "Still closed",
    "reopen_all": "Reopen all of it",
    "reopen_some": "{n, plural, one {Reopen the # course ticked} other {Reopen the # courses ticked}}",
    "done_review": "{area} stays closed. The next review is in a day.",
    "done_reopen": "{area} is reopened. Each course takes its normal weather status at the next hourly check.",
    "done_reopen_some": "{n, plural, one {# course reopened.} other {# courses reopened.}}",
    "error": {
      "forbidden": "Only an owner can do this. The backup contact can close an area only while away mode is on, and can never reopen one.",
      "event_kind_required": "Pick what has happened.",
      "area_name_required": "Write the area's name.",
      "unknown_area": "Pick at least one county or state from the list.",
      "bad_shape": "The circle or the shape is not right. Check the numbers, then try again.",
      "no_courses_in_zone": "There is no course in that area, so there is nothing to close.",
      "bad_tropical_word": "Pick hurricane, typhoon or cyclone.",
      "unknown_template": "That note is not one the founder approved. Pick another.",
      "area_name_mismatch": "The name you typed does not match the area's name. Type it exactly.",
      "what_checked_required": "Write what you checked.",
      "backup_cannot_edit_note": "As the backup contact you can use the note only as it stands.",
      "note_refused": "The note breaks a rule. Change its words, then try again.",
      "closure_not_found": "That closure was not found. Refresh the page.",
      "closure_lifted": "That closure is already reopened. Refresh the page.",
      "not_in_this_closure": "A course you ticked is not closed by this closure. Refresh the page."
    }
  }
}
